module.exports = __webpack_public_path__ + "img/category-Drama.74a7ac35.svg";